import { Icon } from "@iconify/react";
import { Title, Text } from "@mantine/core";
import React from "react";

export default function ModalHeader({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  return (
    <div>
      <Title order={5} c="white" fw={600}>
        {title}
      </Title>

      {subtitle && (
        <Text size="sm" c="dimmed">
          {subtitle}
        </Text>
      )}
    </div>
  );
}
